/**
 * Descripción: Registro de componentes reutilizables
 *
 * @displayName core.js
 */

import Vue from 'vue';

/**
 * Formulario
 */
import BaseForm from '@/components/core/forms/BaseForm.vue';

/**
 * Input
 */
import BaseInput from '@/components/core/forms/BaseInput.vue';

/**
 * Input
 */
import BaseTextArea from '@/components/core/forms/BaseTextArea.vue';

/**
 * AutoComplete
 */
import BaseSelect from '@/components/core/forms/BaseSelect.vue';

/**
 * InputList
 */
import BaseInputList from '@/components/core/forms/BaseInputList.vue';

/**
 * Input
 */
import BaseSwitch from '@/components/core/forms/BaseSwitch.vue';

/**
 * Input
 */
import BaseDatePicker from '@/components/core/forms/BaseDatePicker.vue';

/**
 * Modales
 */
import BaseDialog from '@/components/core/alerts/BaseDialog.vue';

/**
 * Loader
 */
import BaseSkeletonLoader from '@/components/core/layouts/BaseSkeletonLoader.vue';

/**
 * Registro de Componente
 */
Vue.component(BaseForm.name, BaseForm);

/**
 * Registro de Componente
 */
Vue.component(BaseInput.name, BaseInput);

/**
 * Registro de Componente
 */
Vue.component(BaseTextArea.name, BaseTextArea);

/**
 * Registro de Componente
 */
Vue.component(BaseSelect.name, BaseSelect);

/**
 * Registro de Componente
 */
Vue.component(BaseInputList.name, BaseInputList);

/**
 * Registro de Componente
 */
Vue.component(BaseSwitch.name, BaseSwitch);

/**
 * Registro de Componente
 */
Vue.component(BaseDatePicker.name, BaseDatePicker);

/**
 * Registro de Componente
 */
Vue.component(BaseDialog.name, BaseDialog);

/**
 * Registro de Componente
 */
Vue.component(BaseSkeletonLoader.name, BaseSkeletonLoader);

/**
 * Interpolación de String's Vue App
 */
String.prototype.format = function() {
  var a = this;
  for (var k in arguments) {
    a = a.replace(new RegExp('\\{' + k + '\\}', 'g'), arguments[k]);
  }
  return a;
};
